import { Person, PlusCircleFill, ShieldFillPlus } from "react-bootstrap-icons";
import { Icon } from "ui";
import { useAppSelector } from "store";
export const useSidebarItem = () => {
  const userState = useAppSelector((state) => state.dashboard.userState);
  const sidebarItems = [
    {
      title: "داشبورد",
      icon: <Icon type="home" style={{ fontSize: "18px" }} />,
      href: "/dashboard",
      enable: userState === "RECEIVE_IPG",
    },
    {
      title: "ایجاد کسب و کار جدید",
      icon: <PlusCircleFill />,
      href: "/new-business",
      enable: userState === "RECEIVE_IPG",
    },
    {
      title: "واریز درگاهی",
      icon: <Icon type="transactions" style={{ fontSize: "9px" }} />,
      href: "/transactions",
      enable: userState === "RECEIVE_IPG",
    },

    {
      title: "واریز بانکی",
      icon: <Icon type="wallet" style={{ fontSize: "18px" }} />,
      href: "/checkout",
      enable: userState === "RECEIVE_IPG",
    },
    {
      title: "تسویه شاپرکی",
      icon: <Icon type="checkouts" style={{ fontSize: "14px" }} />,
      href: "/wages",
      enable: userState === "RECEIVE_IPG",
    },
    {
      title: "درگاه های پرداخت",
      icon: <Icon type="terminals" />,
      href: "/terminals",
      enable: userState === "RECEIVE_IPG",
    },
    {
      title: "اهراز هویت",
      icon: <ShieldFillPlus size={"16px"} />,
      href: "/authentication",
      enable: true,
    },
    {
      title: "حساب کاربری",
      icon: <Person size={"18px"} />,
      href: "/account",
      enable: true,
    },
  ];
  return { sidebarItems };
};
